function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import usePhoneInput from "../../../../Hooks/usePhoneInput";
import useInput from "../../../../Hooks/useInput";
import PhoneInput from "react-phone-input-2";
import useData from "./data";
import { LoadingSpinner, DetailProjectLoadingUI } from "../../../Common/LoadingUI";
import ProjectDetail from "../../Components/ProjectDetail";
import ProjectGallery from "../../Components/ProjectGallery";
import ProjectConsUpdate from "../../Components/ProjectConsUpdate";
import ProjectAmenities from "../../Components/ProjectAmenities";
import ProjectLocation from "../../Components/ProjectLocation";
import ProjectFaq from "../../Components/ProjectFaq";
import "./index.css";
import VRGallery from "../../Components/VR";
import { toast } from "react-toastify";
import GrClose from "@meronex/icons/gr/GrClose";
import EiCloseO from "@meronex/icons/ei/EiCloseO";
import ProjectDocs from "../../Components/ProjectDocs";
import ProjectBrochures from "../../Components/ProjectBrochure";
import Disclaimer from "../../Components/Disclaimer";
import TiTick from "@meronex/icons/ti/TiTick.js";
import SiWhatsapp from "@meronex/icons/si/SiWhatsapp";
import FaFacebookF from "@meronex/icons/fa/FaFacebookF";
import FiCopy from "@meronex/icons/fi/FiCopy.js";
import MdcEmailOutline from "@meronex/icons/mdc/MdcEmailOutline";
import EnShareAlternative from "@meronex/icons/en/EnShareAlternative";
import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import { scrollToTargetAdjusted } from "../../../../utils/ui.js";
import Modal from "../../../Common/Modal";
import { copyCodeHandler } from "../../../../utils/helpers";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Content = function Content(props) {
  var _config$sectionBackgr, _config$sectionBackgr2, _config$sectionBackgr3, _config$sectionBackgr4, _config$sectionBackgr5, _config$sectionBackgr6, _config$sectionBackgr7, _config$sectionBackgr8, _config$sectionBackgr9, _config$projects, _config$projects2, _config$projects3, _config$projects4, _config$projects5, _config$myProfile, _config$projects6, _config$deals$darkThe, _config$projects7, _config$projects8, _config$deals$darkThe2, _projectDetails$addre, _config$myProfile2;
  var propertyBackgroundColorWithOverlay = props.propertyBackgroundColorWithOverlay,
    headerClass = props.headerClass,
    config = props.config,
    winnreNoAuth = props.winnreNoAuth,
    winnreAuth = props.winnreAuth,
    location = props.location,
    history = props.history,
    VideoModal = props.VideoModal,
    isAuthenticated = props.isAuthenticated,
    userRole = props.userRole,
    userName = props.userName,
    userDetails = props.userDetails,
    userHashProp = props.userHash,
    internalWebview = props.internalWebview,
    auth = props.auth,
    setUserHash = props.setUserHash,
    openLoginModal = props.openLoginModal,
    APIErrorCondition = props.APIErrorCondition,
    RE_EMAIL = props.RE_EMAIL,
    appType = props.appType,
    _props$amenitiesLabel = props.amenitiesLabel,
    amenitiesLabel = _props$amenitiesLabel === void 0 ? "Amenities" : _props$amenitiesLabel;
  var search = (location === null || location === void 0 ? void 0 : location.search) || (typeof window !== "undefined" ? window.location.search : "");
  var queryParams = new URLSearchParams(search);
  var projectId = queryParams.get("projectId");
  var _useData = useData(projectId, {
      winnreNoAuth: winnreNoAuth,
      winnreAuth: winnreAuth
    }, appType),
    projectDetails = _useData.projectDetails,
    highlightCategories = _useData.highlightCategories,
    projectAdditionalHighlights = _useData.projectAdditionalHighlights,
    projectAmenities = _useData.projectAmenities,
    projectGallery = _useData.projectGallery,
    constructionGallery = _useData.constructionGallery,
    loadingProject = _useData.loadingProject,
    VrGallery = _useData.VrGallery,
    projectDocs = _useData.projectDocs,
    projectBrochure = _useData.projectBrochure,
    projectFaqs = _useData.projectFaqs;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    terms = _useState2[0],
    setTerms = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showModal = _useState4[0],
    setShowModal = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    modalMessage = _useState6[0],
    setModalMessage = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    copiedUrl = _useState8[0],
    setCopiedUrl = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    loading = _useState0[0],
    setLoading = _useState0[1];
  var _useState1 = useState("faq"),
    _useState10 = _slicedToArray(_useState1, 2),
    activeButton = _useState10[0],
    setActiveButton = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showShareModal = _useState12[0],
    setShowShareModal = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    playReferralVideo = _useState14[0],
    setPlayReferralVideo = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    videoWatchedCheckbox = _useState16[0],
    setVideoWatchedCheckbox = _useState16[1];
  var _ref = userDetails || {},
    userMobileNumber = _ref.mobileNumber,
    userEmail = _ref.email;
  var userId = userHashProp;
  var isJPConfig = (config === null || config === void 0 ? void 0 : config.clientId) == "51808609e781b8dd8ba561acf88914887185adba2fe5a2698192e9d19d24dc53";
  var isKRCConfig = (config === null || config === void 0 ? void 0 : config.clientId) == "89dcfa41903ebba52c0b371d5dcdddb67e8bfd8daf8fea6019ada584de2af9ca";
  var link = "".concat(window.location.href.split("?")[0], "?projectId=").concat(projectId, "&userId=").concat(userId);

  // openLoginModal, copyCodeHandler, and internalWebview are provided via props

  var userHash = queryParams.get("userId");
  var _useState17 = useState(queryParams.get("userId") !== null),
    _useState18 = _slicedToArray(_useState17, 2),
    fromInfluencerLink = _useState18[0],
    setFromInfluencerLink = _useState18[1];
  var handleVideoWatchedChange = function handleVideoWatchedChange() {
    setVideoWatchedCheckbox(!videoWatchedCheckbox);
  };
  console.log("USer Details", userDetails, userRole, auth, config);
  useEffect(function () {
    if (userHash) {
      var url = "https://api.in.webengage.com/v1/accounts/".concat(config === null || config === void 0 ? void 0 : config.webengageLic, "/events");
      var requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer ".concat(config === null || config === void 0 ? void 0 : config.WAK)
        },
        body: JSON.stringify({
          userId: userHash,
          eventName: "InfluencerLinkViewed",
          eventData: {
            ProjectName: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectName
          }
        })
      };
      fetch(url, requestOptions).then(function (res) {
        // console.log(res);
      })["catch"](function (err) {
        // console.log(err);
      });
    }
  }, [userHash]);
  useEffect(function () {
    var _window;
    var timer = setTimeout(function () {
      setCopiedUrl(false);
    }, 1500);

    // if (queryParams.get("userId") && typeof setUserHash === "function") {
    //   setUserHash(queryParams.get("userId"));
    // }

    // WEBENGAGE for project selection
    var webengageProject = {
      ProjectName: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectName) !== undefined ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectName : "",
      ProjectImage: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectBgImage) !== undefined ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectBgImage : "",
      DevelopmentStatus: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.status) !== undefined ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.status : "",
      ProjectDetails: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectDescription) !== undefined ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectDescription : "",
      Configuration: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.apartmentTypeNames) !== undefined ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.apartmentTypeNames : "",
      Possession: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.possessionDate) !== undefined ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.possessionDate : "",
      Address: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.address) !== undefined ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.address : "",
      BasePrice: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.price) !== undefined ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.price : 0,
      Area: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.area) !== undefined ? projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.area : ""
    };
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("ProjectViewed", webengageProject);
    return function () {
      clearTimeout(timer);
    };
  }, [copiedUrl]);
  var _usePhoneInput = usePhoneInput(),
    _usePhoneInput$state = _usePhoneInput.state,
    mobileNumberIsValid = _usePhoneInput$state.isValid,
    mobile = _usePhoneInput$state.mobile,
    country = _usePhoneInput$state.country,
    mobileHasError = _usePhoneInput$state.mobileHasError,
    isInputFocused = _usePhoneInput$state.isInputFocused,
    onChange = _usePhoneInput.onChange,
    validator = _usePhoneInput.validator,
    setMobile = _usePhoneInput.setMobile,
    setIsTouched = _usePhoneInput.setIsTouched,
    getMobileWithoutCountryCode = _usePhoneInput.getMobileWithoutCountryCode,
    setInputFocused = _usePhoneInput.setInputFocused;
  var _useInput = useInput(function (value) {
      return value.trim() !== "";
    }),
    name = _useInput.value,
    nameIsValid = _useInput.isValid,
    nameHasError = _useInput.hasError,
    nameChangedHandler = _useInput.valueChangeHandler,
    nameBlurHandler = _useInput.inputBlurHandler,
    resetNameInput = _useInput.reset;
  var _useInput2 = useInput(function (value) {
      return RE_EMAIL ? RE_EMAIL.test(value) : true;
    }),
    email = _useInput2.value,
    emailIsValid = _useInput2.isValid,
    emailHasError = _useInput2.hasError,
    emailChangedHandler = _useInput2.valueChangeHandler,
    emailBlurHandler = _useInput2.inputBlurHandler,
    resetEmailInput = _useInput2.reset;
  var _useInput3 = useInput(function (value) {
      return value.trim() !== "";
    }),
    comments = _useInput3.value,
    commentsChangedHandler = _useInput3.valueChangeHandler,
    resetcommentsInput = _useInput3.reset;
  var termsOnChangeHandler = function termsOnChangeHandler() {
    setTerms(!terms);
  };
  var formIsValid = false;
  if (nameIsValid && mobileNumberIsValid && terms && videoWatchedCheckbox) {
    if (email !== "") {
      if (emailIsValid) {
        formIsValid = true;
      }
    } else {
      formIsValid = true;
    }
  }
  var enquireNowHandler = function enquireNowHandler() {
    if (!isAuthenticated) {
      openLoginModal();
      return;
    }
    if (userRole == "CUSTOMER") {
      enquirySubmission({
        initiateSelfReferral: true
      });
    } else {
      executeScrollReferral();
    }
  };
  var bookSiteVisitHandler = function bookSiteVisitHandler() {
    if (isAuthenticated) {
      history.push("/projects/book-a-site-visit?id=".concat(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.id, "&image=").concat(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectBgImage, "&name=").concat(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectName, "&city=").concat(projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.city));

      // history.push({
      //     pathname: `/projects/book-a-site-visit?id=${projectDetails?.id}&image=${projectDetails?.projectBgImage}&name=${projectDetails?.projectName}&city=${projectDetails?.city}`,
      //     state: {
      //         projectId: projectDetails?.id,
      //         projectBgImage: projectDetails?.projectBgImage,
      //         projectCity: projectDetails?.city,
      //         projectName: projectDetails?.projectName
      //     }
      // });
    } else {
      openLoginModal && openLoginModal();
    }
  };
  var enquirySubmission = function enquirySubmission(_ref2) {
    var _ref2$initiateSelfRef = _ref2.initiateSelfReferral,
      initiateSelfReferral = _ref2$initiateSelfRef === void 0 ? false : _ref2$initiateSelfRef;
    var enquiryData;
    if (initiateSelfReferral) {
      enquiryData = {
        name: userName,
        mobileNumber: userMobileNumber,
        projectId: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.id,
        referralSource: "CUSTOMER",
        source: "REFERRAL",
        email: userEmail
      };
    } else {
      enquiryData = {
        name: name,
        mobileNumber: getMobileWithoutCountryCode(),
        projectId: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.id,
        referralSource: "CUSTOMER",
        source: "REFERRAL",
        email: email,
        comment: comments
      };
    }
    winnreAuth({
      method: "post",
      url: "/winnre/user/enquiry",
      data: JSON.stringify(enquiryData),
      headers: {
        "Content-Type": "application/json;charset=utf-8"
      }
    }).then(function (res) {
      setLoading(false);
      // console.log(res);
      if ((res === null || res === void 0 ? void 0 : res.status) === APIErrorCondition) {
        toast.error(res.message);
      } else {
        setShowModal(true);
        if (initiateSelfReferral) {
          setModalMessage("Thank You for your Enquiry. Someone from our team will contact you shortly!");
        } else {
          setModalMessage("Thank You. Someone from our team will contact you shortly!");
          resetcommentsInput();
          resetNameInput();
          resetEmailInput();
          setMobile("+91");
          setTerms(false);
          setIsTouched(false);
        }
      }
    })["catch"](function () {
      toast.error("Something went wrong!");
    });
  };
  var influencerLinkSubmission = function influencerLinkSubmission() {
    var data = {
      userHash: userHash,
      leadName: name,
      leadMobileNumber: getMobileWithoutCountryCode(),
      leadMobileCountryCode: country.dialCode,
      leadEmail: email,
      leadCountry: country === null || country === void 0 ? void 0 : country.countryCode.toUpperCase(),
      leadProjectId: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.id,
      comment: comments
    };
    winnreAuth({
      method: "POST",
      url: "/winnre/user/enquiry/refer-from-link/",
      params: data
    }).then(function (res) {
      setLoading(false);
      if ((res === null || res === void 0 ? void 0 : res.status) == APIErrorCondition) {
        toast.error(res.message);
      } else {
        setModalMessage("Thank you. Someone from our team will contact you shortly!");
        setShowModal(true);
        resetcommentsInput();
        resetNameInput();
        resetEmailInput();
        setMobile("+91");
        setTerms(false);
        setIsTouched(false);
        return;
      }
    })["catch"](function () {
      toast.error("Something went wrong! Please try again!");
    });
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setShowModal(true);
    if (fromInfluencerLink) {
      influencerLinkSubmission();
    } else if (isAuthenticated) {
      enquirySubmission({});
    }
  };
  var handleShareClick = function handleShareClick(e) {
    // e.preventDefault();
    setShowShareModal(true);
  };
  var bookNowHandler = function bookNowHandler() {
    if (!isAuthenticated) {
      openLoginModal();
      return;
    }
    window.open("https://rzp.io/i/GJSRKdg");
  };
  var referralForm = function referralForm() {
    return /*#__PURE__*/_jsxs("div", {
      id: "referral_form",
      className: "mt-8",
      children: [/*#__PURE__*/_jsx("p", {
        className: "font-semibold text-xl text-primary ".concat(config.fontTitle),
        children: userRole !== "SITE_VISITOR" && (userHash === undefined || userHash === null) ? "Get Rewarded on Successful Referrals" : "Exclusive Offers Await!"
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-4",
        children: /*#__PURE__*/_jsxs("form", {
          onSubmit: handleSubmit,
          className: " p-6 bg-transparent rounded-xl border-2 max-w-screen md:w-full relative  3xl:h-[400px] mx-auto ",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex",
            children: [/*#__PURE__*/_jsx("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "43.352",
              height: "48",
              viewBox: "0 0 43.352 48",
              children: /*#__PURE__*/_jsxs("g", {
                id: "gift-box-39",
                transform: "translate(-183.7 -174)",
                children: [/*#__PURE__*/_jsx("path", {
                  id: "Path_6443",
                  "data-name": "Path 6443",
                  d: "M333.289,547.907v-.073a2.908,2.908,0,0,1-2.073.872H330.6a.739.739,0,1,1,0-1.479h.614a1.429,1.429,0,0,0,1.426-1.426v-.462a.741.741,0,0,1,.647-.733v-1.221a.741.741,0,0,1-.647-.733v-.726a.741.741,0,0,1,.647-.733v-3.044H320.434v11.779h11.435A2.149,2.149,0,0,0,333.289,547.907Zm-.4-21.207H320.434v9.983h12.848v-8.742A2.077,2.077,0,0,0,332.886,526.7Zm-13.931,0h-10.6a2.266,2.266,0,0,0-2.258,2.258v7.725h12.848V526.7Zm0,11.462H306.107v10.577a2.259,2.259,0,0,0,.35,1.2h12.505V538.162Z",
                  transform: "translate(-114.319 -329.413)",
                  fill: "#63c0b2"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_6444",
                  "data-name": "Path 6444",
                  d: "M697.913,541.206a.433.433,0,0,1,.092-.007.738.738,0,0,1,.74.739v.726a.738.738,0,0,1-.74.74c-.033,0-.059-.007-.092-.007v1.215a.437.437,0,0,1,.092-.007.738.738,0,0,1,.74.74v.462a2.887,2.887,0,0,1-.832,2.034v.073a2.175,2.175,0,0,1-1.413,2.027h1.967a1.429,1.429,0,0,0,1.426-1.426V538.162h-1.981Zm.654-14.5c-.033,0-.066-.007-.1-.007h-.951a2.123,2.123,0,0,1,.4,1.241v8.742h1.981v-9.448a2.168,2.168,0,0,0-1.281-.528Z",
                  transform: "translate(-478.943 -329.413)",
                  fill: "#00ac9a"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_6445",
                  "data-name": "Path 6445",
                  d: "M254.539,573.146a.738.738,0,0,0,.739-.739v-1.367a.739.739,0,1,0-1.479,0v1.367A.738.738,0,0,0,254.539,573.146Z",
                  transform: "translate(-65.472 -370.134)"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_6446",
                  "data-name": "Path 6446",
                  d: "M252.448,366.7h18.494a1.708,1.708,0,0,0,1.7-1.7v-5.625a2.04,2.04,0,0,0-1.314-.475H235.467a1.369,1.369,0,0,0-1.367,1.367v5.216a1.952,1.952,0,0,0,.442,1.228h17.906Z",
                  transform: "translate(-47.072 -172.692)",
                  fill: "#f7f797"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_6447",
                  "data-name": "Path 6447",
                  d: "M223.869,183.309H213.728a5.39,5.39,0,1,0-8.359-6.629,5.39,5.39,0,1,0-8.359,6.629H186.882a3.184,3.184,0,0,0-3.182,3.182v5.81a3.184,3.184,0,0,0,3.182,3.182H188.7a2.89,2.89,0,0,0-.376,1.426v1.07a.739.739,0,1,0,1.479,0v-1.07a1.429,1.429,0,0,1,1.426-1.426h13.4v11.772H189.807v-1.472a.739.739,0,1,0-1.479,0v13.311A2.905,2.905,0,0,0,191.233,222h28.285a2.905,2.905,0,0,0,2.905-2.905V196.911a2.909,2.909,0,0,0-.376-1.426h1.822a3.184,3.184,0,0,0,3.182-3.182v-5.81A3.184,3.184,0,0,0,223.869,183.309Zm-18.494-1.2a5.566,5.566,0,0,0,.951,1.2h-1.908A5.4,5.4,0,0,0,205.376,182.114Zm4.655-6.629a3.9,3.9,0,0,1,3.182,1.644c.007.007.007.013.013.02a3.907,3.907,0,0,1-5.447,5.447c-.007-.007-.013-.007-.02-.013a3.911,3.911,0,0,1,2.271-7.1ZM196.813,179.4a3.911,3.911,0,0,1,7.1-2.271c.007.007.007.013.013.02a3.907,3.907,0,0,1-5.447,5.447c-.007-.007-.013-.007-.02-.013A3.908,3.908,0,0,1,196.813,179.4Zm-9.93,14.611a1.708,1.708,0,0,1-1.7-1.7V186.5a1.708,1.708,0,0,1,1.7-1.7h36.987a1.708,1.708,0,0,1,1.7,1.7v5.81a1.708,1.708,0,0,1-1.7,1.7ZM220.945,219.1a1.429,1.429,0,0,1-1.426,1.426h-13.4V208.749h14.829Zm-29.711,1.426a1.429,1.429,0,0,1-1.426-1.426V208.749h14.829v11.779Zm29.711-23.61V207.27H206.115V195.5h13.4A1.419,1.419,0,0,1,220.945,196.917Z",
                  transform: "translate(0)"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_6448",
                  "data-name": "Path 6448",
                  d: "M395.086,214.72a3.991,3.991,0,0,1-.231-.35A3.991,3.991,0,0,0,395.086,214.72Zm5.539-3.777a3.243,3.243,0,0,0-6.325,1.439,3.812,3.812,0,0,0,.522,1.928,3.883,3.883,0,0,0,5.8-3.367Zm-.013-1.578c-.007-.007-.007-.013-.013-.02s-.033-.026-.053-.04a.483.483,0,0,0,.066.059Zm-5.467,5.434c.007.007.013.007.02.013a.59.59,0,0,1-.059-.066A.369.369,0,0,0,395.145,214.8Zm9.31,0c.007.007.013.007.02.013a.6.6,0,0,1-.059-.066A.365.365,0,0,0,404.455,214.8Zm5.46-5.434c-.007-.007-.007-.013-.013-.02s-.033-.026-.053-.04c.026.02.046.046.066.059Zm-5.526,5.355a3.9,3.9,0,0,1-.231-.343C404.23,214.488,404.309,214.607,404.389,214.72Zm5.546-3.777a3.243,3.243,0,0,0-6.325,1.439,3.813,3.813,0,0,0,.522,1.928,3.883,3.883,0,0,0,5.8-3.367Z",
                  transform: "translate(-196.695 -32.222)",
                  fill: "#63c0b2"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_6449",
                  "data-name": "Path 6449",
                  d: "M407.8,216.664a3.53,3.53,0,0,0-.4-.264,3.881,3.881,0,0,1-5.289,5.3H402.1a.229.229,0,0,1,.033.053,4,4,0,0,0,.231.35.114.114,0,0,0,.026.033c.02.02.04.046.059.066a3.907,3.907,0,0,0,5.447-5.447.6.6,0,0,0-.066-.059C407.818,216.684,407.811,216.671,407.8,216.664Zm9.31,0a3.255,3.255,0,0,0-.4-.264,3.881,3.881,0,0,1-5.289,5.3h-.007a.229.229,0,0,1,.033.053,3.121,3.121,0,0,0,.231.343.115.115,0,0,0,.026.033.594.594,0,0,1,.059.066,3.907,3.907,0,0,0,5.447-5.447.59.59,0,0,0-.066-.059A.143.143,0,0,1,417.107,216.664Z",
                  transform: "translate(-203.98 -39.601)",
                  fill: "#00ac9a"
                }), /*#__PURE__*/_jsx("path", {
                  id: "Path_6450",
                  "data-name": "Path 6450",
                  d: "M668.78,750.446v.462a1.429,1.429,0,0,1-1.426,1.426h-.614a.739.739,0,1,0,0,1.479h.614a2.908,2.908,0,0,0,2.905-2.905v-.462a.738.738,0,0,0-.74-.74c-.033,0-.059.007-.092.007A.736.736,0,0,0,668.78,750.446Zm0-3.407v.726a.741.741,0,0,0,.647.733.436.436,0,0,0,.092.007.738.738,0,0,0,.74-.74v-.726a.738.738,0,0,0-.74-.739c-.033,0-.059.007-.092.007A.736.736,0,0,0,668.78,747.039Z",
                  transform: "translate(-450.456 -534.514)",
                  fill: "#fff"
                })]
              })
            }), /*#__PURE__*/_jsx("p", {
              className: "ml-2 text-lg md:text-xl text-[632e3e] w-full md:w-1/2 ".concat(config.fontBody),
              children: userRole !== "SITE_VISITOR" && (userHash === undefined || userHash === null) ? "Find your loved ones their Dream Home & Get Rewarded\xA0for\xA0it." : "Please enter the details of the person who is looking to buy with us :"
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "grid grid-cols-1 md:grid-cols-2  pt-4",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "my-2 w-full",
              children: [/*#__PURE__*/_jsx("input", {
                type: "text",
                placeholder: "Referral Name*",
                className: "h-12 text-md bg-white xs:text-base w-full md:w-11/12 border-2 border-[#EBEAF2] px-3 py-2 rounded focus:outline-none ",
                value: name,
                onBlur: nameBlurHandler,
                onChange: nameChangedHandler
              }), nameHasError && /*#__PURE__*/_jsx("p", {
                className: "text-left font-medium text-red-500 text-sm mt-2 ".concat(config.fontTitle),
                children: "Please enter a valid name."
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "my-2 w-full md:w-[91%]",
              children: [/*#__PURE__*/_jsx("div", {
                className: "h-12",
                children: /*#__PURE__*/_jsx(PhoneInput, {
                  country: "in",
                  countryCodeEditable: false,
                  containerClass: "bg-white h-10 rounded outline-none border-none ".concat(isInputFocused ? "outline-none " : ""),
                  onlyCountries: ["in", "hk", "id", "kw", "my", "om", "qa", "sa", "sg", "ae", "gb", "eu", "us", "th"],
                  containerStyle: {
                    width: "100%",
                    boxShadow: "0px",
                    border: "none",
                    outline: "none",
                    borderRadius: "none",
                    marginTop: "-1.5px",
                    height: "100%"
                  },
                  inputStyle: _defineProperty(_defineProperty({
                    width: "100%",
                    height: "100%",
                    border: "none",
                    borderRadius: "none"
                  }, "border", "2px solid #EBEAF2"), "backgroundColor", "#FFFFFF"),
                  buttonStyle: _defineProperty({
                    backgroundColor: "#FFFFFF",
                    border: "none"
                  }, "border", "2px solid #EBEAF2"),
                  isValid: validator,
                  onChange: onChange,
                  value: mobile,
                  enableSearch: true,
                  onBlur: function onBlur() {
                    setIsTouched(true);
                    setInputFocused(false);
                  },
                  onFocus: function onFocus() {
                    return setInputFocused(true);
                  },
                  inputClass: ""
                })
              }), mobileHasError && /*#__PURE__*/_jsx("p", {
                className: "text-left font-medium text-red-500 text-sm mt-2",
                children: "Please enter a valid phone number."
              })]
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("input", {
                type: "text",
                placeholder: "Referral Email",
                className: "h-12 text-md my-2 bg-white xs:text-base w-full md:w-11/12 border-2 border-[#EBEAF2] px-3 py-2 rounded focus:outline-none ",
                value: email,
                onBlur: emailBlurHandler,
                onChange: emailChangedHandler
              }), emailHasError && /*#__PURE__*/_jsx("p", {
                className: "text-left font-medium text-red-500 text-sm ".concat(config.fontTitle),
                children: "Please enter a valid email."
              })]
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("input", {
                type: "text",
                className: "h-12 text-md my-2 bg-white xs:text-base w-full md:w-11/12 border-2 border-[#EBEAF2] px-3 py-2 rounded focus:outline-none ",
                placeholder: "Comments",
                value: comments,
                onChange: commentsChangedHandler
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "mt-4 flex items-center",
            children: [/*#__PURE__*/_jsx("input", {
              type: "checkbox",
              checked: terms,
              onChange: termsOnChangeHandler,
              id: "terms_checkbox",
              className: "checkbox w-5 h-5 md:h-7 md:w-7 md:flex-initial my-auto"
            }), /*#__PURE__*/_jsxs("p", {
              className: "text-xs xs:text-sm ml-2 text-left text-[632e3e]  ".concat(config.fontBody),
              children: ["I have agreed to all", /*#__PURE__*/_jsx("a", {
                href: "#",
                className: "hover:underline",
                children: " Terms & Conditions "
              }), "and Privacy Policy laid down by Reloy and its partners/clients"]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex items-center mt-3 text-xs xs:text-sm text-[632e3e] text-left  ".concat(config.fontBody),
            children: [/*#__PURE__*/_jsx("input", {
              type: "checkbox",
              checked: videoWatchedCheckbox,
              onChange: handleVideoWatchedChange,
              id: "terms_checkbox",
              className: "checkbox w-5 h-5 md:h-7 md:w-7 md:flex-initial my-auto"
            }), /*#__PURE__*/_jsx("p", {
              className: " ml-2",
              children: "I have watched the"
            }), /*#__PURE__*/_jsx("p", {
              onClick: function onClick() {
                return setPlayReferralVideo(true);
              },
              className: "ml-1 inline text-primary underline cursor-pointer",
              children: "video"
            }), /*#__PURE__*/_jsx("p", {
              className: "inline ml-1",
              children: "& abide by RERA guidelines"
            })]
          }), /*#__PURE__*/_jsx("button", {
            value: "submit",
            type: "submit",
            disabled: !formIsValid,
            className: "rounded-lg cursor-pointer disabled:cursor-not-allowed font-medium bg-primary disabled:hover:bg-gray-200 disabled:hover:border-none disabled:bg-gray-200 hover:bg-white text-white disabled:hover:text-white hover:text-primary hover:border hover:border-primary px-10 h-10 mt-4 xs:mt-6 ".concat(config.fontBody),
            children: "Submit"
          })]
        })
      }), showModal && (Modal ? /*#__PURE__*/_jsx(Modal, {
        visible: showModal,
        showButton: true,
        showCloseButton: false,
        onClick: function onClick() {
          return setShowModal(false);
        },
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col px-5 items-center",
          children: [/*#__PURE__*/_jsx(GrClose, {
            onClick: function onClick() {
              return setShowModal(false);
            },
            className: "self-end h-5 w-5 cursor-pointer "
          }), loading && (LoadingSpinner ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : /*#__PURE__*/_jsx("p", {
            children: "Loading..."
          })), !loading && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("div", {
              className: " rounded-full bg-green-500 p-2 md:p-4 animate-pulse",
              children: /*#__PURE__*/_jsx(TiTick, {
                className: " text-white h-7 w-7 md:h-8 md:w-8"
              })
            }), /*#__PURE__*/_jsx("p", {
              className: "my-4 text-center",
              children: modalMessage
            })]
          })]
        })
      }) : /*#__PURE__*/_jsx("div", {
        className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
        children: /*#__PURE__*/_jsxs("div", {
          className: "bg-white p-6 rounded-xl w-full max-w-md relative",
          children: [/*#__PURE__*/_jsx("button", {
            className: "absolute top-3 right-3",
            onClick: function onClick() {
              return setShowModal(false);
            },
            children: /*#__PURE__*/_jsx(GrClose, {})
          }), loading ? /*#__PURE__*/_jsx("p", {
            children: "Loading..."
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("div", {
              className: " rounded-full bg-green-500 p-2 md:p-4 animate-pulse",
              children: /*#__PURE__*/_jsx(TiTick, {
                className: " text-white h-7 w-7 md:h-8 md:w-8"
              })
            }), /*#__PURE__*/_jsx("p", {
              className: "my-4 text-center",
              children: modalMessage
            })]
          })]
        })
      })), VideoModal && /*#__PURE__*/_jsx(VideoModal, {
        isVisible: playReferralVideo,
        setIsVisible: setPlayReferralVideo,
        videoUrl: isJPConfig ? "https://www.youtube.com/watch?v=aHuIQ03nB3E" : isKRCConfig ? "https://www.youtube.com/watch?v=fuiQBGDBmuY" : "https://www.youtube.com/watch?v=XRSjvfJTLc8"
      })]
    });
  };
  var referNowHandler = function referNowHandler() {
    if (isAuthenticated) {
      executeScrollReferral();
    } else {
      openLoginModal();
    }
  };
  var executeScrollAmen = function executeScrollAmen() {
    return scrollToTargetAdjusted("amenities", config);
  };
  var executeScrollLoc = function executeScrollLoc() {
    return scrollToTargetAdjusted("location_highlights", config);
  };
  var executeScrollGallery = function executeScrollGallery() {
    return scrollToTargetAdjusted("gallery", config);
  };
  var executeScrollReferral = function executeScrollReferral() {
    scrollToTargetAdjusted("referral_form", config);
  };
  var executeScrollFAQ = function executeScrollFAQ() {
    setActiveButton("faq");
    scrollToTargetAdjusted("faq", config);
  };
  var executeScrollSalesKit = function executeScrollSalesKit() {
    setActiveButton("sales_kit");
    scrollToTargetAdjusted("sales_kit", config);
  };
  var executeScrollContactSM = function executeScrollContactSM() {
    setActiveButton("contact_sm");
    scrollToTargetAdjusted("contact_sm", config);
  };
  var executeScrollAddLead = function executeScrollAddLead() {
    setActiveButton("add_lead");
    scrollToTargetAdjusted("add_lead", config);
  };
  var getButtonClass = function getButtonClass(btnName) {
    return activeButton === btnName ? "text-white py-2 bg-primary border-2 border-primary rounded-md w-full text-center hover:bg-primary-dark transition-all duration-200 shadow-sm" : "py-2 border-2 border-gray-200 bg-white rounded-md w-full text-center hover:bg-gray-50 transition-all duration-200 shadow-sm whitespace-nowrap";
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [loadingProject && /*#__PURE__*/_jsx("div", {
      className: "h-screen flex items-center justify-center",
      children: DetailProjectLoadingUI ? /*#__PURE__*/_jsx(DetailProjectLoadingUI, {}) : /*#__PURE__*/_jsx("p", {
        children: "Loading..."
      })
    }), !loadingProject && /*#__PURE__*/_jsxs(_Fragment, {
      children: [headerClass.addHeader && /*#__PURE__*/_jsx("div", {
        className: "".concat(headerClass === null || headerClass === void 0 ? void 0 : headerClass.headerClass, " ").concat(config === null || config === void 0 ? void 0 : config.bannerNegativeTopMarginClass)
      }), /*#__PURE__*/_jsxs("div", {
        className: "".concat(headerClass.addHeader ? "" : config === null || config === void 0 ? void 0 : config.bannerNegativeTopMarginClass, " relative \n        ").concat(config !== null && config !== void 0 && (_config$sectionBackgr = config.sectionBackground) !== null && _config$sectionBackgr !== void 0 && _config$sectionBackgr.image ? "bg-transparent" : config !== null && config !== void 0 && config.darkMode ? "bg-black" : "".concat(config !== null && config !== void 0 && config.setSolidBg ? config === null || config === void 0 ? void 0 : config.setSolidBg : "bg-white"), "\n    "),
        style: {
          backgroundImage: "linear-gradient(90deg, rgba(".concat(config === null || config === void 0 || (_config$sectionBackgr2 = config.sectionBackground) === null || _config$sectionBackgr2 === void 0 ? void 0 : _config$sectionBackgr2.color, ", ").concat(config === null || config === void 0 || (_config$sectionBackgr3 = config.sectionBackground) === null || _config$sectionBackgr3 === void 0 ? void 0 : _config$sectionBackgr3.opacity, "), rgba(").concat(config === null || config === void 0 || (_config$sectionBackgr4 = config.sectionBackground) === null || _config$sectionBackgr4 === void 0 ? void 0 : _config$sectionBackgr4.color, ", ").concat(config === null || config === void 0 || (_config$sectionBackgr5 = config.sectionBackground) === null || _config$sectionBackgr5 === void 0 ? void 0 : _config$sectionBackgr5.opacity, ")), url('").concat(config !== null && config !== void 0 && (_config$sectionBackgr6 = config.sectionBackground) !== null && _config$sectionBackgr6 !== void 0 && _config$sectionBackgr6.image ? config === null || config === void 0 || (_config$sectionBackgr7 = config.sectionBackground) === null || _config$sectionBackgr7 === void 0 ? void 0 : _config$sectionBackgr7.image : "", "')"),
          backgroundSize: "".concat(config !== null && config !== void 0 && (_config$sectionBackgr8 = config.sectionBackground) !== null && _config$sectionBackgr8 !== void 0 && _config$sectionBackgr8.size ? config === null || config === void 0 || (_config$sectionBackgr9 = config.sectionBackground) === null || _config$sectionBackgr9 === void 0 ? void 0 : _config$sectionBackgr9.size : "30% auto")
        },
        children: [(config === null || config === void 0 || (_config$projects = config.projects) === null || _config$projects === void 0 || (_config$projects = _config$projects.moduleConfig) === null || _config$projects === void 0 ? void 0 : _config$projects.overlayClass) && /*#__PURE__*/_jsx("div", {
          style: {
            zIndex: -1
          },
          className: "".concat(config === null || config === void 0 || (_config$projects2 = config.projects) === null || _config$projects2 === void 0 || (_config$projects2 = _config$projects2.moduleConfig) === null || _config$projects2 === void 0 ? void 0 : _config$projects2.overlayClass, " opacity-0 absolute top-0 bottom-0 left-0 right-0")
        }), /*#__PURE__*/_jsxs("div", {
          className: "lg:flex z-10",
          children: [/*#__PURE__*/_jsx("div", {
            className: "z-10 flex md:flex",
            children: /*#__PURE__*/_jsxs("div", {
              className: "z-20 lg:h-[200vh] lg:sticky lg:top-0 w-[100vw] lg:w-[30vw] lg:pl-8 lg:pr-4 pt-8 pb-2 lg:py-8 ".concat((config === null || config === void 0 || (_config$projects3 = config.projects) === null || _config$projects3 === void 0 || (_config$projects3 = _config$projects3.moduleConfig) === null || _config$projects3 === void 0 ? void 0 : _config$projects3.leftPaneColor) !== undefined ? config === null || config === void 0 || (_config$projects4 = config.projects) === null || _config$projects4 === void 0 || (_config$projects4 = _config$projects4.moduleConfig) === null || _config$projects4 === void 0 ? void 0 : _config$projects4.leftPaneColor : ""),
              children: [/*#__PURE__*/_jsx("div", {
                className: "z-20 lg:hidden max-h-full px-6",
                children: /*#__PURE__*/_jsx("img", {
                  variant: "square",
                  loading: "lazy",
                  className: " ".concat(config !== null && config !== void 0 && (_config$projects5 = config.projects) !== null && _config$projects5 !== void 0 && (_config$projects5 = _config$projects5.moduleConfig) !== null && _config$projects5 !== void 0 && _config$projects5.QRCodeImage ? "h-full max-h-full " : "h-56 max-h-56 ", " z-10\n                            w-full mb-4 object-center object-cover rounded-lg"),
                  src: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectBgImage,
                  alt: "property"
                })
              }), /*#__PURE__*/_jsx(ProjectDetail, {
                fromInfluencerLink: fromInfluencerLink,
                referClick: executeScrollReferral,
                projectDetails: projectDetails,
                config: config,
                location: location,
                history: history
              }), /*#__PURE__*/_jsxs("div", {
                className: "".concat(config.fontTitle, " z-10 grid grid-cols-3 gap-2 xl:gap-3 2xl:gap-4  py-2 mt-4 sm:mt-2 md:mt-4 lg:mt-2 xl:mt-4 mb-2 px-8 lg:px-0 -ml-0 xl:-ml-4 2xl:-ml-0"),
                children: [/*#__PURE__*/_jsx("button", {
                  className: "z-10 hover:text-primary text-sm xl:text-[16px] text-left xl:text-center  border-gray-200 ",
                  onClick: executeScrollGallery,
                  children: "Galleries"
                }), /*#__PURE__*/_jsx("button", {
                  className: " z-10 hover:text-primary   text-sm xl:text-[16px] text-left   xl:text-center  border-gray-200 ",
                  onClick: executeScrollAmen,
                  children: amenitiesLabel
                }), /*#__PURE__*/_jsx("button", {
                  className: " z-10 hover:text-primary  text-left xl:text-center  text-sm xl:text-[16px]  ",
                  onClick: executeScrollLoc,
                  children: "Highlights"
                })]
              }), /*#__PURE__*/_jsxs("svg", {
                viewBox: "0 0 457 2",
                children: [/*#__PURE__*/_jsx("defs", {}), /*#__PURE__*/_jsx("g", {
                  id: "Layer_2",
                  "data-name": "Layer 2",
                  children: /*#__PURE__*/_jsx("g", {
                    id: "Layer_1-2",
                    "data-name": "Layer 1",
                    children: /*#__PURE__*/_jsx("polygon", {
                      "class": "cls-1",
                      points: "0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1",
                      fill: "#e5e5e5"
                    })
                  })
                })]
              }), (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.supportsReferral) && appType !== "winnre" && /*#__PURE__*/_jsxs("div", {
                className: "".concat(config.fontTitle, " flex items-center  mt-6 px-6 lg:px-0 2xl:px-6 ").concat(internalWebview ? "fixed bottom-0 left-0 w-full px-3 py-2 bg-white gap-x-1" : "gap-x-4", "  "),
                style: internalWebview ? {
                  zIndex: 1000,
                  position: "fixed",
                  bottom: "0"
                } : {},
                children: [/*#__PURE__*/_jsx("button", {
                  onClick: enquireNowHandler,
                  className: " text-white py-2 w-[47%] bg-primary rounded-md ",
                  children: "Enquire Now"
                }), userRole !== "CUSTOMER" && /*#__PURE__*/_jsx("button", {
                  onClick: bookSiteVisitHandler,
                  className: "py-2 w-[52%] border-2 border-gray-200 bg-white  rounded-md whitespace-nowrap ",
                  children: "Book A Site Visit"
                }), userRole === "CUSTOMER" && /*#__PURE__*/_jsxs("div", {
                  className: "border-2 border-gray-200 bg-white rounded-md flex items-center gap-[6px] justify-center py-2 w-[50%] ",
                  children: [/*#__PURE__*/_jsx("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "text-primary",
                    width: "17.865",
                    height: "17.998",
                    viewBox: "0 0 17.865 19.998",
                    children: /*#__PURE__*/_jsxs("g", {
                      id: "_7671601_present_gift_packaging_birthday_celebration_icon",
                      "data-name": "7671601_present_gift_packaging_birthday_celebration_icon",
                      transform: "translate(-56.573 -32.76)",
                      children: [/*#__PURE__*/_jsx("path", {
                        id: "Path_6313",
                        "data-name": "Path 6313",
                        d: "M306.42,35.36V36.2a6.133,6.133,0,0,1,3.632-.847l-3.632,1.334v.549h3.494c1.971,0,1.718-2.368.369-3.807l-.051-.054a1.818,1.818,0,0,0-1.326-.614c-1.123,0-2.187,1.113-2.724,1.779A1.529,1.529,0,0,1,306.42,35.36Z",
                        transform: "translate(-238.427)",
                        fill: "currentColor"
                      }), /*#__PURE__*/_jsx("rect", {
                        id: "Rectangle_1842",
                        "data-name": "Rectangle 1842",
                        width: "3.756",
                        height: "3.756",
                        rx: "1.878",
                        transform: "translate(63.629 34.427)",
                        fill: "currentColor"
                      }), /*#__PURE__*/_jsx("path", {
                        id: "Path_6314",
                        "data-name": "Path 6314",
                        d: "M73.955,146.757a1.727,1.727,0,0,0-1.258-.537H67.874a1.543,1.543,0,0,1-1.422.948h-1.89a1.543,1.543,0,0,1-1.422-.948H58.312a1.739,1.739,0,0,0-1.738,1.815l.5,11.436a1.736,1.736,0,0,0,1.738,1.664H72.2a1.736,1.736,0,0,0,1.738-1.664l.5-11.436A1.722,1.722,0,0,0,73.955,146.757ZM63.522,160.224H58.809a.827.827,0,0,1-.829-.792L57.485,148a.829.829,0,0,1,.828-.864h2.1l-1.821,2.706,1.9-.358.19,2.47,2.836-4.575Zm9.508-.792a.827.827,0,0,1-.828.792H67.488V147.435l2.8,4.516.19-2.472,1.9.358-1.821-2.707H72.7a.829.829,0,0,1,.828.864Z",
                        transform: "translate(0 -108.378)",
                        fill: "currentColor"
                      }), /*#__PURE__*/_jsx("path", {
                        id: "Path_6315",
                        "data-name": "Path 6315",
                        d: "M91.994,37.235h3.494v-.549l-3.632-1.334a6.13,6.13,0,0,1,3.632.847V35.36a1.531,1.531,0,0,1,.238-.818c-.537-.666-1.6-1.781-2.726-1.781a1.818,1.818,0,0,0-1.324.613l-.052.054C90.276,34.866,90.021,37.235,91.994,37.235Z",
                        transform: "translate(-32.468)",
                        fill: "currentColor"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("button", {
                    onClick: referNowHandler,
                    className: " whitespace-nowrap rounded-md",
                    children: "Refer Now"
                  })]
                })]
              }), appType === "winnre" && /*#__PURE__*/_jsxs("div", {
                className: "".concat(config.fontTitle, " grid grid-cols-2 gap-4 mt-6 px-6 lg:px-0 2xl:px-6"),
                children: [/*#__PURE__*/_jsx("button", {
                  onClick: executeScrollFAQ,
                  className: getButtonClass("faq"),
                  children: "View FAQs"
                }), /*#__PURE__*/_jsx("button", {
                  onClick: executeScrollSalesKit,
                  className: getButtonClass("sales_kit"),
                  children: "Sales Kit"
                }), isAuthenticated && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx("button", {
                    onClick: executeScrollContactSM,
                    className: getButtonClass("contact_sm"),
                    children: "Contact SM"
                  }), !(config !== null && config !== void 0 && (_config$myProfile = config.myProfile) !== null && _config$myProfile !== void 0 && _config$myProfile.disableNewLead) && /*#__PURE__*/_jsx("button", {
                    onClick: executeScrollAddLead,
                    className: getButtonClass("add_lead"),
                    children: "Add Lead"
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "".concat(config.fontBody, " ").concat(config !== null && config !== void 0 && config.darkMode ? "text-[#9b9b9b] border-[1px]" : "text-gray-600 border-2", "  z-10 mt-6 lg:mt-8 p-3 bordey-gray-200 font-bold rounded mx-6 lg:mx-0  2xl:mx-6"),
                children: [/*#__PURE__*/_jsx("p", {
                  className: config.fontTitle,
                  children: "RERA Details"
                }), /*#__PURE__*/_jsx("p", {
                  className: "z-10 flex text-sm  md:my-1 my-1 break-all ",
                  children: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.reraNumber
                }), /*#__PURE__*/_jsx("p", {
                  className: "z-10 flex text-sm  md:my-1 my-1 break-all ",
                  children: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.reraWebsite
                })]
              })]
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "w-[100vw] lg:w-[70%] px-8 md:pt-8 \n                            \n                                ",
            children: [/*#__PURE__*/_jsx("div", {
              className: "hidden lg:block z-20 max-h-full flex-1 flex justify-end",
              children: /*#__PURE__*/_jsx("img", {
                variant: "square",
                loading: "lazy",
                className: " ".concat(config !== null && config !== void 0 && (_config$projects6 = config.projects) !== null && _config$projects6 !== void 0 && (_config$projects6 = _config$projects6.moduleConfig) !== null && _config$projects6 !== void 0 && _config$projects6.QRCodeImage ? "h-full max-h-full " : "h-72 max-h-72 ", " z-10\n                            w-full mb-2 object-center object-cover rounded-lg"),
                src: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectBgImage,
                alt: "property"
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: " ".concat(config.fontBody, " z-10 flex justify-between items-center -ml-1.5 lg:-ml-0"),
              children: [/*#__PURE__*/_jsxs("div", {
                className: "flex flex-col",
                children: [/*#__PURE__*/_jsx("p", {
                  className: "z-10 text-xl mt-3 font-bold sm:text-2xl ".concat(config !== null && config !== void 0 && config.darkMode ? (config === null || config === void 0 || (_config$deals$darkThe = config.deals.darkTheme) === null || _config$deals$darkThe === void 0 ? void 0 : _config$deals$darkThe.text) || "text-primary" : "text-[#130E2F]", " ").concat(config.fontTitle),
                  children: projectDetails.projectName
                }), /*#__PURE__*/_jsx("p", {
                  className: "z-10 text-lg italics text-[#908F95] ",
                  children: projectDetails.city
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "z-10 flex  flec row gap-4 items-center justify-center py-2 px-2 md:px-6  text-black w-[130px] ",
                children: [/*#__PURE__*/_jsx("button", {
                  className: "",
                  title: "Click to share",
                  onClick: handleShareClick,
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "flex flex-row items-center gap-[2px] -mt-3 lg:-mt-0 -mr-4 lg:-mr-0",
                    children: [/*#__PURE__*/_jsx(EnShareAlternative, {
                      className: "h-4 w-4 md:h-5 md:w-5"
                    }), /*#__PURE__*/_jsx("p", {
                      className: "font-semibold pl-1 text-lg sm:text-xl underline -mt-1 ",
                      children: "Share"
                    })]
                  })
                }), showShareModal && (Modal ? /*#__PURE__*/_jsx(Modal, {
                  visible: showShareModal,
                  showButton: true,
                  showCloseButton: false,
                  onClick: function onClick() {
                    return setShowShareModal(false);
                  },
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "flex flex-col px-5 ",
                    children: [loading && /*#__PURE__*/_jsx(LoadingSpinner, {}), !loading && /*#__PURE__*/_jsxs(_Fragment, {
                      children: [/*#__PURE__*/_jsxs("div", {
                        className: "flex justify-between items-center my-4 ",
                        children: [/*#__PURE__*/_jsx("h1", {
                          className: " text-lg sm:text-xl font-bold ",
                          children: "Share this Project"
                        }), /*#__PURE__*/_jsx(EiCloseO, {
                          onClick: function onClick() {
                            return setShowShareModal(false);
                          },
                          className: " h-7 w-7 sm:h-9 sm:w-10 cursor-pointer   text-gray-500"
                        })]
                      }), /*#__PURE__*/_jsxs("svg", {
                        viewBox: "0 0 457 2",
                        children: [/*#__PURE__*/_jsx("defs", {}), /*#__PURE__*/_jsx("g", {
                          id: "Layer_2",
                          "data-name": "Layer 2",
                          children: /*#__PURE__*/_jsx("g", {
                            id: "Layer_1-2",
                            "data-name": "Layer 1",
                            children: /*#__PURE__*/_jsx("polygon", {
                              "class": "cls-1",
                              points: "0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1",
                              fill: "#e5e5e5"
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "flex gap-5 items-center my-5",
                        children: [/*#__PURE__*/_jsx("img", {
                          variant: "square",
                          loading: "lazy",
                          className: "".concat(config !== null && config !== void 0 && (_config$projects7 = config.projects) !== null && _config$projects7 !== void 0 && (_config$projects7 = _config$projects7.moduleConfig) !== null && _config$projects7 !== void 0 && _config$projects7.QRCodeImage ? "h-10 w-10" : "h-20 w-28", " z-10  object-center object-cover rounded-lg"),
                          src: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectBgImage,
                          alt: "property"
                        }), /*#__PURE__*/_jsxs("div", {
                          className: "flex flex-col ",
                          children: [/*#__PURE__*/_jsx("p", {
                            className: "text-black font-semibold text-base sm:text-lg",
                            children: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectName
                          }), /*#__PURE__*/_jsx("p", {
                            className: "text-[#908F95] text-sm sm:text-base italic",
                            children: projectDetails.city
                          })]
                        })]
                      }), /*#__PURE__*/_jsxs("svg", {
                        viewBox: "0 0 457 2",
                        children: [/*#__PURE__*/_jsx("defs", {}), /*#__PURE__*/_jsx("g", {
                          id: "Layer_2",
                          "data-name": "Layer 2",
                          children: /*#__PURE__*/_jsx("g", {
                            id: "Layer_1-2",
                            "data-name": "Layer 1",
                            children: /*#__PURE__*/_jsx("polygon", {
                              "class": "cls-1",
                              points: "0 1 57.13 0.51 114.25 0.23 228.5 0 342.75 0.23 399.88 0.51 457 1 399.88 1.49 342.75 1.77 228.5 2 114.25 1.76 57.13 1.49 0 1",
                              fill: "#e5e5e5"
                            })
                          })
                        })]
                      }), /*#__PURE__*/_jsxs("div", {
                        className: "flex flex-wrap justify-between items-center mt-5 ",
                        children: [/*#__PURE__*/_jsx("div", {
                          className: " w-[90%] lg:w-[45%]  md:w-[45%]  cursor-pointer  flex gap-2  border border-gray-400 rounded-[10px] p-3 my-2",
                          children: /*#__PURE__*/_jsxs("button", {
                            title: copiedUrl ? "Link copied" : "Click to copy",
                            className: "",
                            onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
                              var shareLink;
                              return _regenerator().w(function (_context) {
                                while (1) switch (_context.n) {
                                  case 0:
                                    if (!(typeof navigator !== "undefined" && navigator.clipboard)) {
                                      _context.n = 1;
                                      break;
                                    }
                                    shareLink = userRole === "CUSTOMER" || userRole === "CHANNEL_PARTNER" ? link : typeof window !== "undefined" ? window.location.href : "";
                                    _context.n = 1;
                                    return navigator.clipboard.writeText(shareLink);
                                  case 1:
                                    setCopiedUrl(true);
                                  case 2:
                                    return _context.a(2);
                                }
                              }, _callee);
                            })),
                            children: [!copiedUrl && /*#__PURE__*/_jsxs("div", {
                              className: "flex items-center gap-3",
                              children: [/*#__PURE__*/_jsx(FiCopy, {
                                className: "cursor-pointer w-5 h-full"
                              }), /*#__PURE__*/_jsx("p", {
                                className: "font-bold text-sm sm:text-base",
                                children: "Link Copy"
                              })]
                            }), copiedUrl && /*#__PURE__*/_jsx("p", {
                              className: "mx-auto px-6 self-center  rounded-lg text-center font-normal animate-pulse bg-white text-xs sm:text-sm   text-[#006EB7] ",
                              children: "Link Copied"
                            })]
                          })
                        }), /*#__PURE__*/_jsx("div", {
                          className: " w-[90%] lg:w-[45%] md:w-[45%]  cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
                          children: /*#__PURE__*/_jsx(EmailShareButton, {
                            url: userRole === "CUSTOMER" || userRole === "CHANNEL_PARTNER" ? link : window.location.href,
                            title: "Hello! Hope you're doing well. I wanted to share this exciting project I found recently. Here's the link: 🏘️ Click to learn more!",
                            children: /*#__PURE__*/_jsxs("div", {
                              className: "flex items-center gap-3",
                              children: [/*#__PURE__*/_jsx(MdcEmailOutline, {
                                className: "w-5 h-full"
                              }), /*#__PURE__*/_jsx("p", {
                                className: "  font-bold text-sm sm:text-base",
                                children: "Email"
                              })]
                            })
                          })
                        }), /*#__PURE__*/_jsx("div", {
                          className: " w-[90%] lg:w-[45%]  md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
                          children: /*#__PURE__*/_jsx(WhatsappShareButton, {
                            url: userRole === "CUSTOMER" || userRole === "CHANNEL_PARTNER" ? link : window.location.href,
                            title: "Hey there! I came across this amazing project that I think you'd love. Check it out: 🏡 Click on the below link to know more!",
                            children: /*#__PURE__*/_jsxs("div", {
                              className: "flex items-center gap-3",
                              children: [/*#__PURE__*/_jsx(SiWhatsapp, {
                                className: "w-5 h-full"
                              }), /*#__PURE__*/_jsx("p", {
                                className: "  font-bold text-sm sm:text-base ",
                                children: "WhatsApp"
                              })]
                            })
                          })
                        }), /*#__PURE__*/_jsx("div", {
                          className: " w-[90%] lg:w-[45%]  md:w-[45%] cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
                          children: /*#__PURE__*/_jsx(FacebookShareButton, {
                            url: userRole === "CUSTOMER" || userRole === "CHANNEL_PARTNER" ? link : window.location.href,
                            title: "Hey friends! Just stumbled upon this incredible project that I couldn't wait to share with you all. Take a look: 🌟 Click on the below link to explore further!",
                            children: /*#__PURE__*/_jsxs("div", {
                              className: "flex items-center gap-3",
                              children: [/*#__PURE__*/_jsx(FaFacebookF, {
                                className: "w-5 h-full"
                              }), /*#__PURE__*/_jsx("p", {
                                className: "font-bold text-sm sm:text-base ",
                                children: "Facebook"
                              })]
                            })
                          })
                        }), /*#__PURE__*/_jsx("div", {
                          className: " w-[90%] lg:w-[45%]  md:w-[45%]  cursor-pointer flex gap-2 border border-gray-400 rounded-[10px] p-3 my-2",
                          children: /*#__PURE__*/_jsx(TwitterShareButton, {
                            url: userRole === "CUSTOMER" || userRole === "CHANNEL_PARTNER" ? link : window.location.href,
                            title: "Exciting news! Discovered a fantastic project worth checking out. Here's the link: 🏢 Click to learn more!",
                            children: /*#__PURE__*/_jsxs("div", {
                              className: "flex items-center gap-3",
                              children: [/*#__PURE__*/_jsx("svg", {
                                size: 20,
                                className: "w-5 text-black",
                                stroke: "currentColor",
                                fill: "currentColor",
                                "stroke-width": "0",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/_jsx("path", {
                                  d: "M8 2H1L9.26086 13.0145L1.44995 21.9999H4.09998L10.4883 14.651L16 22H23L14.3917 10.5223L21.8001 2H19.1501L13.1643 8.88578L8 2ZM17 20L5 4H7L19 20H17Z"
                                })
                              }), /*#__PURE__*/_jsx("button", {
                                className: "  font-bold text-sm sm:text-base",
                                children: "Twitter"
                              })]
                            })
                          })
                        })]
                      })]
                    })]
                  })
                }) : /*#__PURE__*/_jsx("div", {
                  className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
                  children: /*#__PURE__*/_jsxs("div", {
                    className: "bg-white p-6 rounded-xl w-full max-w-md relative",
                    children: [/*#__PURE__*/_jsx("button", {
                      className: "absolute top-3 right-3",
                      onClick: function onClick() {
                        return setShowShareModal(false);
                      },
                      children: /*#__PURE__*/_jsx(EiCloseO, {})
                    }), /*#__PURE__*/_jsx("div", {
                      className: "flex flex-col px-5 ",
                      children: loading ? /*#__PURE__*/_jsx("p", {
                        children: "Loading..."
                      }) : /*#__PURE__*/_jsxs(_Fragment, {
                        children: [/*#__PURE__*/_jsx("div", {
                          className: "flex justify-between items-center my-4 ",
                          children: /*#__PURE__*/_jsx("h1", {
                            className: " text-lg sm:text-xl font-bold ",
                            children: "Share this Project"
                          })
                        }), /*#__PURE__*/_jsxs("div", {
                          className: "flex gap-5 items-center my-5",
                          children: [/*#__PURE__*/_jsx("img", {
                            variant: "square",
                            loading: "lazy",
                            className: "".concat(config !== null && config !== void 0 && (_config$projects8 = config.projects) !== null && _config$projects8 !== void 0 && (_config$projects8 = _config$projects8.moduleConfig) !== null && _config$projects8 !== void 0 && _config$projects8.QRCodeImage ? "h-10 w-10" : "h-20 w-28", " z-10  object-center object-cover rounded-lg"),
                            src: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectBgImage,
                            alt: "property"
                          }), /*#__PURE__*/_jsxs("div", {
                            className: "flex flex-col ",
                            children: [/*#__PURE__*/_jsx("p", {
                              className: "text-black font-semibold text-base sm:text-lg",
                              children: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectName
                            }), /*#__PURE__*/_jsx("p", {
                              className: "text-[#908F95] text-sm sm:text-base italic",
                              children: projectDetails.city
                            })]
                          })]
                        }), /*#__PURE__*/_jsx("div", {
                          className: "flex flex-wrap justify-between items-center mt-5 ",
                          children: /*#__PURE__*/_jsx("div", {
                            className: " w-[90%] lg:w-[45%]  md:w-[45%]  cursor-pointer  flex gap-2  border border-gray-400 rounded-[10px] p-3 my-2",
                            children: /*#__PURE__*/_jsxs("button", {
                              title: copiedUrl ? "Link copied" : "Click to copy",
                              className: "",
                              onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                                var shareLink;
                                return _regenerator().w(function (_context2) {
                                  while (1) switch (_context2.n) {
                                    case 0:
                                      shareLink = userRole === "CUSTOMER" || userRole === "CHANNEL_PARTNER" ? link : typeof window !== "undefined" ? window.location.href : "";
                                      if (!(typeof navigator !== "undefined" && navigator.clipboard)) {
                                        _context2.n = 2;
                                        break;
                                      }
                                      _context2.n = 1;
                                      return navigator.clipboard.writeText(shareLink);
                                    case 1:
                                      setCopiedUrl(true);
                                    case 2:
                                      return _context2.a(2);
                                  }
                                }, _callee2);
                              })),
                              children: [!copiedUrl && /*#__PURE__*/_jsxs("div", {
                                className: "flex items-center gap-3",
                                children: [/*#__PURE__*/_jsx(FiCopy, {
                                  className: "cursor-pointer w-5 h-full"
                                }), /*#__PURE__*/_jsx("p", {
                                  className: "font-bold text-sm sm:text-base",
                                  children: "Link Copy"
                                })]
                              }), copiedUrl && /*#__PURE__*/_jsx("p", {
                                className: "mx-auto px-6 self-center  rounded-lg text-center font-normal animate-pulse bg-white text-xs sm:text-sm   text-[#006EB7] ",
                                children: "Link Copied"
                              })]
                            })
                          })
                        })]
                      })
                    })]
                  })
                }))]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex flex-col mt-3 -ml-1.5 lg:-ml-0",
              children: [/*#__PURE__*/_jsx("h4", {
                className: "z-10 text-xl mt-2 ".concat(config !== null && config !== void 0 && config.darkMode ? (config === null || config === void 0 || (_config$deals$darkThe2 = config.deals.darkTheme) === null || _config$deals$darkThe2 === void 0 ? void 0 : _config$deals$darkThe2.text) || "text-primary" : "text-[#130E2F]", " font-bold ").concat(config.fontTitle),
                children: "Project Description"
              }), /*#__PURE__*/_jsx("p", {
                className: "".concat(config !== null && config !== void 0 && config.darkMode ? "text-base-content" : "text-[#130E2F]", " mt-2 z-10 ").concat(config.fontBody),
                children: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectDescription
              })]
            }), (projectGallery === null || projectGallery === void 0 ? void 0 : projectGallery.length) > 0 && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(ProjectGallery, {
                projectGallery: projectGallery,
                config: config
              })
            }), (VrGallery === null || VrGallery === void 0 ? void 0 : VrGallery.length) > 0 && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(VRGallery, {
                VrGallery: VrGallery,
                config: config,
                userId: userId,
                location: location,
                winnreNoAuth: winnreNoAuth
              })
            }), !projectDetails.readyToOccupy && /*#__PURE__*/_jsx(ProjectConsUpdate, {
              constructionGallery: constructionGallery,
              constructionProgress: Math.round(projectDetails.constructionProgress * 10) / 10,
              config: config
            }), (projectDocs === null || projectDocs === void 0 ? void 0 : projectDocs.length) > 0 && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(ProjectDocs, {
                documents: projectDocs,
                config: config
              })
            }), projectBrochure.length > 0 && /*#__PURE__*/_jsx("div", {
              id: appType === "winnre" ? "sales_kit" : undefined,
              children: /*#__PURE__*/_jsx(ProjectBrochures, {
                brochure: projectBrochure,
                config: config,
                appType: appType,
                winnreAuth: winnreAuth
              })
            }), (projectAmenities === null || projectAmenities === void 0 ? void 0 : projectAmenities.length) > 0 && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(ProjectAmenities, {
                amenitiesLabel: amenitiesLabel,
                consVisible: !projectDetails.readyToOccupy,
                amenties: projectAmenities,
                propertyBackgroundColorWithOverlay: propertyBackgroundColorWithOverlay,
                config: config
              })
            }), /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(ProjectLocation, {
                consVisible: !projectDetails.readyToOccupy,
                projectId: projectId,
                projectDetails: projectDetails,
                address: (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.address) + ((projectDetails === null || projectDetails === void 0 || (_projectDetails$addre = projectDetails.addressLine2) === null || _projectDetails$addre === void 0 ? void 0 : _projectDetails$addre.length) > 0 ? ", " + projectDetails.addressLine2 : ""),
                highlightCategories: highlightCategories,
                projectAdditionalHighlights: projectAdditionalHighlights,
                config: config
              })
            }), appType === "winnre" && (projectFaqs === null || projectFaqs === void 0 ? void 0 : projectFaqs.length) > 0 && /*#__PURE__*/_jsx("div", {
              id: "faq",
              children: /*#__PURE__*/_jsx(ProjectFaq, {
                faqs: projectFaqs,
                config: config
              })
            }), appType === "winnre" && isAuthenticated && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(ContactSMSection, {
                projectId: projectId,
                projectName: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectName,
                config: config,
                winnreAuth: winnreAuth,
                isAuthenticated: isAuthenticated,
                auth: auth
              }), !(config !== null && config !== void 0 && (_config$myProfile2 = config.myProfile) !== null && _config$myProfile2 !== void 0 && _config$myProfile2.disableNewLead) && /*#__PURE__*/_jsx(AddLeadSection, {
                projectId: projectId,
                projectName: projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.projectName,
                config: config,
                winnreAuth: winnreAuth
              })]
            }), /*#__PURE__*/_jsx("div", {
              children: (isAuthenticated || fromInfluencerLink) && appType !== "winnre" && (projectDetails === null || projectDetails === void 0 ? void 0 : projectDetails.supportsReferral) && referralForm()
            }), /*#__PURE__*/_jsx(Disclaimer, {
              disclaimer: projectDetails.disclaimer,
              config: config
            })]
          })]
        })]
      })]
    })]
  });
};
var ContactSMSection = function ContactSMSection(_ref7) {
  var _config$CONTACT_DETAI, _config$CONTACT_DETAI2, _auth$eligibleRoles2, _auth$eligibleRoles3;
  var projectId = _ref7.projectId,
    initialProjectName = _ref7.projectName,
    config = _ref7.config,
    winnreAuth = _ref7.winnreAuth,
    isAuthenticated = _ref7.isAuthenticated,
    auth = _ref7.auth;
  var _useState19 = useState(projectId),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedProjectId = _useState20[0],
    setSelectedProjectId = _useState20[1];
  var _useState21 = useState(initialProjectName),
    _useState22 = _slicedToArray(_useState21, 2),
    selectedProjectName = _useState22[0],
    setSelectedProjectName = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    projectsList = _useState24[0],
    setProjectsList = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    salesManagers = _useState26[0],
    setSalesManagers = _useState26[1];
  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    loading = _useState28[0],
    setLoading = _useState28[1];
  var _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    supportData = _useState30[0],
    setSupportData = _useState30[1];

  // Fetch support email and mobile
  useEffect(function () {
    winnreAuth({
      url: '/winnre/user/about/help?appType=WINNRE',
      method: 'GET'
    }).then(function (res) {
      console.log(res);
      if (res && res.status !== 'FAILED') {
        setSupportData(res);
      }
    })["catch"](function (err) {
      return console.error("Error fetching support help data", err);
    });
  }, [winnreAuth]);

  // Fetch all projects for the dropdown
  useEffect(function () {
    if (!isAuthenticated) return;
    winnreAuth({
      url: '/winnre/user/project/names',
      method: 'GET'
    }).then(function (res) {
      if (res && res.status !== 'FAILED') {
        setProjectsList(res || []);
      }
    })["catch"](function (err) {
      return console.error("Error fetching projects", err);
    });
  }, [winnreAuth, isAuthenticated]);

  // Fetch Sales Managers when selected project changes
  useEffect(function () {
    var _auth$eligibleRoles;
    if (!selectedProjectId || !isAuthenticated || auth !== null && auth !== void 0 && (_auth$eligibleRoles = auth.eligibleRoles) !== null && _auth$eligibleRoles !== void 0 && _auth$eligibleRoles.some(function (role) {
      return ['SALES', 'FINANCE'].includes(role === null || role === void 0 ? void 0 : role.toUpperCase());
    })) return;
    setLoading(true);
    winnreAuth({
      url: "/winnre/cp/sales-manager/by-project-id?projectId=".concat(selectedProjectId, "&role=SALES_MANAGER&pageNumber=0&pageSize=20"),
      method: 'GET'
    }).then(function (res) {
      setLoading(false);
      if (res && res.content) {
        setSalesManagers(res.content);
      } else {
        setSalesManagers([]);
      }
    })["catch"](function (err) {
      setLoading(false);
      setSalesManagers([]);
      console.error("Error fetching sales managers", err);
    });
  }, [selectedProjectId, winnreAuth, isAuthenticated]);

  // When projectId prop changes, update selection
  useEffect(function () {
    if (projectId) {
      setSelectedProjectId(projectId);
    }
  }, [projectId]);
  useEffect(function () {
    if (initialProjectName) {
      setSelectedProjectName(initialProjectName);
    }
  }, [initialProjectName]);
  var handleProjectSelect = function handleProjectSelect(e) {
    var pId = e.target.value;
    setSelectedProjectId(pId);
    var p = projectsList.find(function (proj) {
      return String(proj.id) === String(pId);
    });
    if (p) {
      setSelectedProjectName(p.projectName);
    }
  };
  var copyToClipboard = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(num, name) {
      var _t;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (!(typeof navigator !== "undefined" && navigator.clipboard)) {
              _context3.n = 4;
              break;
            }
            _context3.p = 1;
            _context3.n = 2;
            return navigator.clipboard.writeText(num);
          case 2:
            toast.success("Mobile number for ".concat(name, " copied to clipboard!"));
            _context3.n = 4;
            break;
          case 3:
            _context3.p = 3;
            _t = _context3.v;
            toast.error("Failed to copy number.");
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function copyToClipboard(_x, _x2) {
      return _ref8.apply(this, arguments);
    };
  }();
  var supportMobile = (supportData === null || supportData === void 0 ? void 0 : supportData.helplineNumber) || (config === null || config === void 0 || (_config$CONTACT_DETAI = config.CONTACT_DETAILS) === null || _config$CONTACT_DETAI === void 0 ? void 0 : _config$CONTACT_DETAI.MOBILE) || "";
  var supportEmail = (supportData === null || supportData === void 0 ? void 0 : supportData.supportEmail) || (supportData === null || supportData === void 0 ? void 0 : supportData.email) || (config === null || config === void 0 || (_config$CONTACT_DETAI2 = config.CONTACT_DETAILS) === null || _config$CONTACT_DETAI2 === void 0 ? void 0 : _config$CONTACT_DETAI2.EMAIL) || "";
  return /*#__PURE__*/_jsxs("div", {
    id: "contact_sm",
    className: "mt-8 flex flex-col z-10 font-Poppins",
    children: [/*#__PURE__*/_jsx("h4", {
      className: "text-xl font-bold my-2 ".concat(config !== null && config !== void 0 && config.darkMode ? "text-primary" : "text-[#130E2F]", " ").concat(config === null || config === void 0 ? void 0 : config.fontTitle),
      children: "Connect with SM"
    }), /*#__PURE__*/_jsxs("div", {
      className: "bg-white p-5 rounded-2xl border-2 border-gray-100 flex items-start gap-4 mb-5 shadow-sm",
      children: [/*#__PURE__*/_jsx("div", {
        className: "w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 text-lg flex-shrink-0",
        children: /*#__PURE__*/_jsxs("svg", {
          className: "w-6 h-6 text-gray-500",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          viewBox: "0 0 24 24",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M3 18v-6a9 9 0 0 1 18 0v6"
          }), /*#__PURE__*/_jsx("path", {
            d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex-1",
        children: [/*#__PURE__*/_jsx("p", {
          className: "text-sm font-medium text-gray-500 leading-tight",
          children: "Contact us for support or Leave your suggestion to help improve"
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-wrap gap-x-6 gap-y-1 mt-2 text-sm font-semibold text-gray-800",
          children: [supportMobile && /*#__PURE__*/_jsx("span", {
            className: "flex items-center gap-1.5 cursor-pointer text-gray-500 hover:text-gray-800",
            onClick: function onClick() {
              return copyToClipboard(supportMobile, "Support");
            },
            children: supportMobile
          }), supportEmail && /*#__PURE__*/_jsx("span", {
            className: "flex items-center gap-1.5 text-gray-500 hover:text-gray-800",
            children: /*#__PURE__*/_jsx("a", {
              href: "mailto:".concat(supportEmail),
              className: "hover:underline",
              children: supportEmail
            })
          })]
        })]
      })]
    }), isAuthenticated && !(auth !== null && auth !== void 0 && (_auth$eligibleRoles2 = auth.eligibleRoles) !== null && _auth$eligibleRoles2 !== void 0 && _auth$eligibleRoles2.some(function (role) {
      return ['SALES', 'FINANCE'].includes(role === null || role === void 0 ? void 0 : role.toUpperCase());
    })) && /*#__PURE__*/_jsxs("div", {
      className: "bg-white p-5 rounded-2xl border border-gray-200 mb-5 shadow-sm",
      children: [/*#__PURE__*/_jsx("label", {
        className: "text-base font-bold text-gray-800 block",
        children: "Select Project"
      }), /*#__PURE__*/_jsx("span", {
        className: "text-sm text-gray-500 block mb-3",
        children: "Which Project is this Regarding"
      }), /*#__PURE__*/_jsxs("select", {
        value: selectedProjectId || "",
        onChange: handleProjectSelect,
        className: "w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary bg-white text-gray-800 font-semibold",
        children: [/*#__PURE__*/_jsx("option", {
          value: "",
          disabled: true,
          children: "Select Project"
        }), projectsList.map(function (p) {
          return /*#__PURE__*/_jsx("option", {
            value: p.id,
            children: p.projectName
          }, p.id);
        }), projectsList.findIndex(function (p) {
          return String(p.id) === String(selectedProjectId);
        }) === -1 && selectedProjectId && /*#__PURE__*/_jsx("option", {
          value: selectedProjectId,
          children: selectedProjectName
        })]
      })]
    }), !(auth !== null && auth !== void 0 && (_auth$eligibleRoles3 = auth.eligibleRoles) !== null && _auth$eligibleRoles3 !== void 0 && _auth$eligibleRoles3.some(function (role) {
      return ['SALES', 'FINANCE'].includes(role === null || role === void 0 ? void 0 : role.toUpperCase());
    })) && (loading ? /*#__PURE__*/_jsx("div", {
      className: "text-center py-6 text-gray-500 font-medium",
      children: "Loading Sales Managers..."
    }) : salesManagers.length === 0 ? /*#__PURE__*/_jsx("div", {
      className: "bg-white p-6 rounded-2xl border-2 border-gray-100 text-center text-gray-500 font-medium shadow-sm",
      children: "No Sales Managers assigned to this project."
    }) : /*#__PURE__*/_jsx("div", {
      className: "grid grid-cols-1 lg:grid-cols-2 gap-4",
      children: salesManagers.map(function (sm, index) {
        var initial = sm.name ? sm.name.charAt(0).toUpperCase() : "V";
        var message = encodeURIComponent("Hi, I would like to connect regarding the project \"".concat(selectedProjectName, "\""));
        return /*#__PURE__*/_jsxs("div", {
          className: "bg-white p-6 rounded-2xl border-2 border-gray-100 shadow-sm flex flex-col gap-5",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex items-center gap-4",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-14 h-14 rounded-full bg-[#f6ad55] flex items-center justify-center text-white font-bold text-2xl flex-shrink-0",
              children: initial
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("h5", {
                className: "font-bold text-lg text-gray-400",
                children: sm.name || "SM Name"
              }), /*#__PURE__*/_jsxs("div", {
                className: "mt-1",
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-xs text-gray-400 font-medium",
                  children: "Mobile Number"
                }), /*#__PURE__*/_jsx("p", {
                  className: "text-sm text-gray-600 font-semibold",
                  children: sm.mobileNumber || "-"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "mt-1",
                children: [/*#__PURE__*/_jsx("p", {
                  className: "text-xs text-gray-400 font-medium",
                  children: "Email Address"
                }), /*#__PURE__*/_jsx("p", {
                  className: "text-sm text-gray-600 font-semibold",
                  children: sm.email || "-"
                })]
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex flex-col gap-3",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "grid grid-cols-2 gap-4",
              children: [/*#__PURE__*/_jsxs("a", {
                href: sm.email ? "mailto:".concat(sm.email, "?subject=").concat(encodeURIComponent("Inquiry regarding ".concat(selectedProjectName)), "&body=").concat(message) : "#",
                onClick: function onClick(e) {
                  if (!sm.email) e.preventDefault();
                },
                className: "flex items-center justify-center gap-2 py-3 bg-[#3182ce] hover:bg-[#2b6cb0] text-white font-bold rounded-xl transition-all shadow-sm cursor-pointer",
                children: [/*#__PURE__*/_jsx("svg", {
                  className: "w-4 h-4",
                  fill: "none",
                  stroke: "currentColor",
                  strokeWidth: "2",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: /*#__PURE__*/_jsx("path", {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  })
                }), "Email"]
              }), /*#__PURE__*/_jsxs("a", {
                href: sm.mobileNumber ? "https://wa.me/+91".concat(sm.mobileNumber.replace(/\D/g, ""), "?text=").concat(message) : "#",
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: function onClick(e) {
                  if (!sm.mobileNumber) e.preventDefault();
                },
                className: "flex items-center justify-center gap-2 py-3 bg-[#38a169] hover:bg-[#2f855a] text-white font-bold rounded-xl transition-all shadow-sm cursor-pointer",
                children: [/*#__PURE__*/_jsx("svg", {
                  className: "w-4 h-4",
                  fill: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: /*#__PURE__*/_jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.58.413 3.126 1.2 4.488L3 21l4.633-1.215a8.936 8.936 0 0 0 4.417 1.17h.003c4.951 0 8.979-4.027 8.981-8.977a8.924 8.924 0 0 0-2.634-6.345zm-6.35 13.812h-.002a7.47 7.47 0 0 1-3.812-1.047l-.273-.162-2.83.742.756-2.76-.178-.283a7.447 7.447 0 0 1-1.137-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.42 7.42 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.185 5.277c-.002 4.116-3.348 7.464-7.462 7.467zm4.09-5.59c-.224-.112-1.324-.653-1.528-.727-.204-.074-.352-.112-.5.112-.148.224-.574.727-.704.876-.13.149-.26.168-.483.056-.224-.112-.947-.349-1.804-1.113-.667-.595-1.117-1.33-1.248-1.554-.13-.224-.014-.346.098-.458.101-.1.224-.26.335-.39.112-.13.149-.224.224-.374.075-.15.038-.28-.019-.393-.056-.112-.5-1.204-.686-1.653-.18-.435-.364-.376-.5-.383-.13-.006-.278-.007-.427-.007-.15 0-.39.056-.594.28-.204.224-.778.76-0.778 1.85 0 1.092.793 2.146.904 2.296.112.15 1.56 2.38 3.778 3.334.528.228.94.364 1.263.467.53.169 1.012.145 1.393.088.425-.063 1.324-.54 1.51-.1.185-.506.185-1.07 0-.13-.056-.224-.204-.299z"
                  })
                }), "Whatsapp"]
              })]
            }), /*#__PURE__*/_jsxs("button", {
              onClick: function onClick() {
                return sm.mobileNumber && copyToClipboard(sm.mobileNumber, sm.name);
              },
              disabled: !sm.mobileNumber,
              className: "flex items-center justify-center gap-2 py-3 bg-[#1a202c] hover:bg-[#2d3748] text-white font-bold rounded-xl transition-all shadow-sm w-full disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer",
              children: [/*#__PURE__*/_jsx("svg", {
                className: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/_jsx("path", {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  d: "M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                })
              }), "Make a Call"]
            })]
          })]
        }, index);
      })
    }))]
  });
};
var AddLeadSection = function AddLeadSection(_ref9) {
  var _config$leads;
  var projectId = _ref9.projectId,
    projectName = _ref9.projectName,
    config = _ref9.config,
    winnreAuth = _ref9.winnreAuth;
  var _useState31 = useState({
      register: "New Customer",
      name: "",
      email: "",
      comments: ""
    }),
    _useState32 = _slicedToArray(_useState31, 2),
    formData = _useState32[0],
    setFormData = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    emailTouched = _useState34[0],
    setEmailTouched = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    loading = _useState36[0],
    setLoading = _useState36[1];
  var _useState37 = useState(""),
    _useState38 = _slicedToArray(_useState37, 2),
    siteVisit = _useState38[0],
    setSiteVisit = _useState38[1];
  var hideNewCustomer = (config === null || config === void 0 || (_config$leads = config.leads) === null || _config$leads === void 0 ? void 0 : _config$leads.hideNewCustomer) === true;
  var _usePhoneInput2 = usePhoneInput(),
    _usePhoneInput2$state = _usePhoneInput2.state,
    currentMobileNumberIsValid = _usePhoneInput2$state.isValid,
    currentMobile = _usePhoneInput2$state.mobile,
    mobileHasError = _usePhoneInput2$state.mobileHasError,
    currentMobileOnChange = _usePhoneInput2.onChange,
    currentMobileValidator = _usePhoneInput2.validator,
    setCurrentMobileIsTouched = _usePhoneInput2.setIsTouched,
    resetMobile = _usePhoneInput2.reset;
  useEffect(function () {
    if (hideNewCustomer && formData.register === "New Customer") {
      setFormData(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          register: "Site Visit"
        });
      });
    }
  }, [hideNewCustomer]);
  var isValidEmail = function isValidEmail(email) {
    if (!email) return false;
    var re = /[^\s@]+@[^\s@]+\.[^\s@]+/;
    return re.test(String(email).toLowerCase());
  };
  var handleChange = function handleChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    setFormData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, value));
    });
  };
  var isFormValid = function isFormValid() {
    var baseValidation = formData.name && formData.email && isValidEmail(formData.email) && currentMobileNumberIsValid;
    if (formData.register === "Site Visit") {
      return baseValidation && siteVisit;
    }
    return baseValidation;
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var now, selected, requestData, res, _t2;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            if (isFormValid()) {
              _context4.n = 1;
              break;
            }
            toast.error("Please fill all fields correctly.");
            return _context4.a(2);
          case 1:
            if (!(formData.register === "Site Visit")) {
              _context4.n = 2;
              break;
            }
            now = new Date();
            selected = siteVisit ? new Date(siteVisit) : null;
            if (!(!selected || selected <= now)) {
              _context4.n = 2;
              break;
            }
            toast.error("Please select a future date and time.");
            return _context4.a(2);
          case 2:
            setLoading(true);
            _context4.p = 3;
            requestData = _objectSpread({
              comment: formData.comments || "",
              email: formData.email,
              mobileCountryCode: 91,
              mobileNumber: currentMobile,
              name: formData.name,
              projectId: Number(projectId)
            }, formData.register === "Site Visit" && {
              timestamp: new Date(siteVisit).toISOString()
            });
            _context4.n = 4;
            return winnreAuth({
              url: "/winnre/user/enquiry",
              method: "POST",
              data: requestData
            });
          case 4:
            res = _context4.v;
            if (!((res === null || res === void 0 ? void 0 : res.status) === "INVALID_TOKEN" || (res === null || res === void 0 ? void 0 : res.status) === "FAILED")) {
              _context4.n = 5;
              break;
            }
            toast.error("Something went wrong");
            return _context4.a(2);
          case 5:
            toast.success("Lead registered successfully!");
            setFormData({
              register: hideNewCustomer ? "Site Visit" : "New Customer",
              name: "",
              email: "",
              comments: ""
            });
            setSiteVisit("");
            resetMobile();
            setEmailTouched(false);
            _context4.n = 7;
            break;
          case 6:
            _context4.p = 6;
            _t2 = _context4.v;
            toast.error("Failed to register lead.");
          case 7:
            _context4.p = 7;
            setLoading(false);
            return _context4.f(7);
          case 8:
            return _context4.a(2);
        }
      }, _callee4, null, [[3, 6, 7, 8]]);
    }));
    return function handleSubmit() {
      return _ref0.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_jsxs("div", {
    id: "add_lead",
    className: "mt-8 flex flex-col z-10",
    children: [/*#__PURE__*/_jsx("h4", {
      className: "text-xl font-bold my-2 ".concat(config !== null && config !== void 0 && config.darkMode ? "text-primary" : "text-[#130E2F]", " ").concat(config === null || config === void 0 ? void 0 : config.fontTitle),
      children: "Add Lead"
    }), /*#__PURE__*/_jsxs("div", {
      className: "bg-white p-6 rounded-xl border-2 border-gray-200 w-full",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "grid grid-cols-1 md:grid-cols-2 gap-4",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("label", {
            className: "text-base font-medium text-gray-700",
            children: ["Register Option ", /*#__PURE__*/_jsx("span", {
              className: "text-red-500",
              children: "*"
            })]
          }), /*#__PURE__*/_jsxs("select", {
            name: "register",
            value: formData.register,
            onChange: handleChange,
            className: "w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary bg-white text-gray-800 font-normal",
            children: [!hideNewCustomer && /*#__PURE__*/_jsx("option", {
              value: "New Customer",
              children: "New Customer"
            }), /*#__PURE__*/_jsx("option", {
              value: "Site Visit",
              children: "Site Visit"
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("label", {
            className: "text-base font-medium text-gray-700",
            children: ["Name ", /*#__PURE__*/_jsx("span", {
              className: "text-red-500",
              children: "*"
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            name: "name",
            value: formData.name,
            onChange: handleChange,
            placeholder: "Enter Lead Name",
            className: "w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary text-gray-800 font-normal"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("label", {
            className: "text-base font-medium text-gray-700",
            children: ["Email Address ", /*#__PURE__*/_jsx("span", {
              className: "text-red-500",
              children: "*"
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "email",
            name: "email",
            value: formData.email,
            onChange: handleChange,
            onBlur: function onBlur() {
              return setEmailTouched(true);
            },
            placeholder: "Enter Email Address",
            className: "w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary text-gray-800 font-normal"
          }), emailTouched && !isValidEmail(formData.email) && /*#__PURE__*/_jsx("p", {
            className: "text-sm text-red-500 mt-1",
            children: "Enter a valid email address"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col",
          children: [/*#__PURE__*/_jsxs("label", {
            className: "text-base font-medium text-gray-700 mb-1",
            children: ["Mobile Number ", /*#__PURE__*/_jsx("span", {
              className: "text-red-500",
              children: "*"
            })]
          }), /*#__PURE__*/_jsx(PhoneInput, {
            country: "in",
            countryCodeEditable: false,
            containerClass: "peer border border-gray-300 rounded-md w-full h-[42px] focus-within:ring-1 focus-within:ring-primary focus-within:border-primary text-gray-800 bg-white",
            containerStyle: {
              width: "100%",
              outline: "none"
            },
            buttonStyle: {
              backgroundColor: "white",
              border: "none"
            },
            inputStyle: {
              width: "100%",
              height: "100%",
              border: "none",
              outline: "none",
              paddingLeft: "44px",
              fontSize: "16px",
              color: "#1f2937"
            },
            isValid: currentMobileValidator,
            onChange: currentMobileOnChange,
            value: currentMobile,
            enableSearch: true,
            onBlur: function onBlur() {
              setCurrentMobileIsTouched(true);
            }
          }), mobileHasError && /*#__PURE__*/_jsx("p", {
            className: "text-left text-sm mt-1 text-red-500",
            children: "Please enter a valid number"
          })]
        }), formData.register === "Site Visit" && /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("label", {
            className: "text-base font-medium text-gray-700",
            children: ["Site Visit Date & Time ", /*#__PURE__*/_jsx("span", {
              className: "text-red-500",
              children: "*"
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "datetime-local",
            value: siteVisit,
            min: new Date().toISOString().slice(0, 16),
            onChange: function onChange(e) {
              var selected = new Date(e.target.value);
              var now = new Date();
              if (selected > now) {
                setSiteVisit(e.target.value);
              } else {
                toast.error("Please select a future date and time.");
                setSiteVisit("");
              }
            },
            className: "w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary text-gray-800 bg-white font-normal"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("label", {
            className: "text-base font-medium text-gray-700",
            children: ["Project ", /*#__PURE__*/_jsx("span", {
              className: "text-red-500",
              children: "*"
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            value: projectName || "Selected Project",
            disabled: true,
            className: "w-full mt-1 p-2 border border-gray-200 bg-gray-50 rounded-md text-gray-600 font-semibold cursor-not-allowed"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "md:col-span-2",
          children: [/*#__PURE__*/_jsx("label", {
            className: "text-base font-medium text-gray-700",
            children: "Comments"
          }), /*#__PURE__*/_jsx("textarea", {
            name: "comments",
            value: formData.comments,
            onChange: handleChange,
            placeholder: "Enter Comments",
            className: "w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary text-gray-800 font-normal",
            rows: 3
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-6 flex justify-end",
        children: /*#__PURE__*/_jsx("button", {
          onClick: handleSubmit,
          disabled: !isFormValid() || loading,
          className: "bg-primary text-white font-semibold px-6 py-2.5 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-opacity-90 transition-all shadow-sm",
          children: loading ? "Registering..." : "Register"
        })
      })]
    })]
  });
};
export default Content;